module.exports = __webpack_public_path__ + "static/media/SFPro-Regular.47667ce6.woff2";